// extracted by mini-css-extract-plugin
export default {"TextInput":"styles_TextInput__2hDoK"};